export enum PartnerField {
  Name = 'name',
  Code = 'code',
  Description = 'description',
  CanSell = 'canSell',
  Special = 'special',
  CreatedBy = 'createdBy',
}

export const partnerLabels = {
  [PartnerField.Code]: 'Partner code',
  [PartnerField.Name]: 'Partner name',
  [PartnerField.Description]: 'Description',
  [PartnerField.CanSell]: 'Can sell traffic',
  [PartnerField.Special]: 'Is partner special',
};
